import { render, staticRenderFns } from "./QueryCommissionMenu.vue?vue&type=template&id=4cba63bc&"
import script from "./QueryCommissionMenu.vue?vue&type=script&lang=js&"
export * from "./QueryCommissionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports